import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./manage-users.scss";
import AddEditUserModal from "../../components/add-edit-user-modal/add-edit-user-modal";
import DeleteUserConfirmationModal from "../../components/delete-user-confirmation-modal/delete-user-confirmation-modal";
import ManageMemberUtils from "../../utils/manage-member-utils";

const ManageUsersPage = () => {
  const { userInfo } = useSelector((state) => state.userStore);

  const [users, setUsers] = useState([]);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const refreshUsers = async () => {
    const response = await ManageMemberUtils.fetchAllMembers();
    setUsers(response);
  };

  useEffect(() => {
    refreshUsers();
  }, []);

  const handleEditUser = (user) => {
    setSelectedUser(user);
    setShowAddEditModal(true);
  };

  const handleDeleteUser = (user) => {
    setSelectedUser(user);
    setShowDeleteModal(true);
  };

  const confirmDeleteUser = async () => {
    if (selectedUser) {
      const updatedUser = { ...selectedUser, status: "deleted" };
      await ManageMemberUtils.updateMember(updatedUser);
      refreshUsers();
      setShowDeleteModal(false);
      setSelectedUser(null);
    }
  };

  const toggleUserStatus = async (user) => {
    const updatedUser = {
      ...user,
      status: user.status === "active" ? "inactive" : "active",
    };
    await ManageMemberUtils.updateMember(updatedUser);
    refreshUsers();
  };

  const handleCloseAddEditModal = () => {
    setShowAddEditModal(false);
    setSelectedUser(null);
  };

  return (
    <>
      <div className="container-fluid">{/* Page-Title */}</div>
      <div className="row">
        <div className="col-12">
          <h1 class="m-0 mb-4">User Management</h1>
          <div className="">
            <button
              className="bouncy-button small"
              onClick={() => {
                setSelectedUser(null);
                setShowAddEditModal(true);
              }}
            >
              <i className="mdi mdi-plus"></i> <span>Add New User</span>
            </button>
            <div className="tableWrapper mt-3">
              <div className="table-responsive">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th>Email</th>
                      <th>Name</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Contact No</th>
                      <th>Edit / Deactivate / Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <tr key={user._id}>
                        <td>{user.email}</td>
                        <td>{user.name || "--"}</td>
                        <td>{user.role}</td>
                        <td>
                          <span
                            className={`badge ${
                              user.status === "active"
                                ? "badge-soft-success"
                                : "badge-soft-danger"
                            }`}
                          >
                            {user.status.charAt(0).toUpperCase() +
                              user.status.slice(1)}
                          </span>
                        </td>
                        <td>{user.phone || "--"}</td>
                        <td>
                          {/* Conditionally hide actions if it's the logged-in user */}
                          {user.email !== userInfo.email && (
                            <>
                              <button
                                className="bouncy-button white small me-1"
                                onClick={() => handleEditUser(user)}
                              >
                                <i className="mdi mdi-pencil"></i>
                                {/* <span>Edit</span> */}
                              </button>
                              <button
                                className="bouncy-button white small me-1"
                                onClick={() => toggleUserStatus(user)}
                              >
                                {user.status === "active" ? <i className="mdi mdi-account-off"></i> : <i className="mdi mdi-account-check"></i>}{" "}
                                {/* <span> {user.status === "active" ? "Deactivate" : "Activate"} </span> */}
                              </button>
                              <button
                                className="bouncy-button negative small"
                                onClick={() => handleDeleteUser(user)}
                              >
                                <i className="mdi mdi-delete"></i>
                                {/* <span>Delete</span> */}
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddEditUserModal
        show={showAddEditModal}
        onClose={handleCloseAddEditModal}
        user={selectedUser}
        onUserUpdated={refreshUsers}
      />
      <DeleteUserConfirmationModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={confirmDeleteUser}
        userName={selectedUser?.name}
      />
    </>
  );
};

export default ManageUsersPage;
